import type { NodeViewProps } from "@tiptap/vue-3";
import { useProvideLinkEditContext } from "ls/features/disko/links/useLinkEditContext";
import { computed, ref, watch } from "vue";
import { useIsThisNodeOnlySelection, useSelectionIntersectsNodeView } from "../useSelectionIntersectsNodeView";
import { useLinkNodeClick } from "./useLinkNodeClick";

export function useLinkNode(props: NodeViewProps) {
  const { requestSubmit } = useProvideLinkEditContext();

  const selectionIntersects = useSelectionIntersectsNodeView(props, { allowEmpty: false });
  const thisNodeOnlySelected = useIsThisNodeOnlySelection(props);

  const selectedOrIntersects = computed(() => {
    return props.selected || selectionIntersects.value;
  });

  const isMaximized = ref(false);
  const isEditing = ref(false);
  const keepOpen = ref(false);

  const close = () => {
    isEditing.value = false;
  };

  const handleUpdateOpen = async (open: boolean) => {
    if (!open) {
      if (isEditing.value) {
        await requestSubmit();
        close();
      }
    }
    keepOpen.value = open;
  };

  const showToolbar = computed(() => {
    if (keepOpen.value) return true;
    if (isMaximized.value) return false;
    if (thisNodeOnlySelected.value) return true;
    return false;
  });

  watch(showToolbar, () => {
    isEditing.value = false;
  });

  const { isPointer, handleLinkClick } = useLinkNodeClick(() => !props.view.editable);

  return {
    selected: selectedOrIntersects,
    isMaximized,
    isEditing,
    showToolbar,
    isPointer,
    handleUpdateOpen,
    close,
    handleLinkClick,
  };
}
